export const TYPE = {
    LATEST: 'latest',
    FOUNDATION: 'foundation'
};